//
//
//
//
//
//
//
//
//
//
//
//
//

import payPublic from '@/javascript/payPublic'
import axios from "axios"

export default {
  name: 'collection',
  props: {
    collectParams: Object,
    isLogin: Boolean
  },
  data () {
    return {
      params: this.collectParams,
      userInfo: '',
      collect: {},
      login: this.isLogin
    }
  },
  mounted () {
    const _this = this
    if (_this.login) {
      _this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      _this.init(_this.params)
    }
  },
  watch: {
    params: {
      handler (newValue, oldValue) {
        if (this.login) {
          this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
          this.init(newValue)
        }
      }
    }
  },
  methods: {
    init (info) {
      /* 判断该条内容是否被收藏 */
      this.$http.get('/api/wtcp-member/public/favorite/existFav?access_token=' + this.userInfo.token + '&deptCode=' + this.DEPT_CODE.DEPTCODE + '&title=' + encodeURI(info.title) + '&url=' + encodeURIComponent(info.articleSite)).then((response) => {
        this.$set(this, 'collect', response.data)
      })
    },
    collectItem () {
      const _this = this
      if (_this.login) {
        if (_this.collect.status == 0) {
          const param = {
            catalog: Number(_this.params.catalog), //类别
            deptCode: _this.DEPT_CODE.DEPTCODE, //组织机构编码
            isDelete: 0, //是否删除（1：是，0：否）
            picUrl: _this.params.picUrl, //图片URL
            principalId: _this.params.principalId, //被收藏对象id
            serviceType: _this.params.serviceType, //浏览信息所属的服务类型
            summary: _this.params.summary, //简介
            title: _this.params.title, //浏览信息页面的标题
            url: _this.params.articleSite, //浏览页面信息的地址
            userId: _this.userInfo.userid, //会员ID
            username: _this.userInfo.username ? _this.userInfo.username : '', //登录账号
          }
          _this.$http.post('/api/wtcp-member/public/favorite?access_token=' + _this.userInfo.token, param).then((response) => {
            if (response.data.status == 1) {
              _this.collect.status = 1
              payPublic.showPrompt(`收藏成功`)
              _this.init(_this.params)
            }
          })
        } else {
          // _this.$http.delete('/api/wtcp-member/public/favorite/delete?access_token=' + _this.userInfo.token + '&id=' + _this.collect.data.id ).then((response) => {
          //     if (response.data.status == 1) {
          //         _this.collect.status = 0
          //         payPublic.showPrompt(`取消收藏`)
          //     }
          // })
          axios({
            method: "delete",
            url: '/api/wtcp-member/public/favorite/delete?access_token=' + _this.userInfo.token + '&id=' + _this.collect.data.id,
          }).then(response => {
            if (response.data.status == 1) {
              _this.collect.status = 0
              payPublic.showPrompt(`取消收藏`)
            }
          })
        }
      } else {
        // 调用父组件中的登陆方法
        _this.$parent.fatherMethod();
      }
    }
  }
}
